module.exports = __webpack_public_path__ + "static/JetBrainsMono-Medium-Italic-dd0da6de6c2340f4bf0aa4108f98a63f.woff2";